<template>
  <div id="homepage">
    <section>
    </section>
    <section class="section" id="hero">
      <div class="container">
          <h1 class="is-size-3-mobile has-text-centered" style="margin-bottom:1em;"> I Festival online de programación creativa para estudiantes </h1>
          <div class="columns">
            <div class="column">
                <p> <span class="has-text-weight-bold"> Medialab-Prado </span> tiene una fachada de LED gigante en el centro de Madrid. Con Programalaplaza puedes desarollar tu proyecto y exponerlo.</p>
              </div>
              <div class="column">
                <p> Este año, ProgramaLaPlaza se abre especialmente a <span class="has-text-weight-bold"> estudiantes, </span> como lienzo abierto donde mostrar todo lo que sabéis hacer. </p>
              </div>
          </div>
        <div class="columns is-gapless reverse-row">
          <div class="column is-10 video-container">
            <video src="/static/videos/video1.mp4" autoplay loop poster="" style="width:100%; border: 4px black solid; border-radius:8px;" >
            </video>
          </div>
          <div class="column is-2 text-container" style="z-index:2" >
            <div  class="catch-phrase-container" style="border-radius: 8px;">
              <h1 class="is-size-3-mobile"> Demuestra que sabes programar <br/> <span style="font-size:1.0em"> a lo grande </span></h1>
            </div>
            <div  class="btn-container">
              <router-link :to="{ name: 'Editor.create'}" class="button is-success" id="btn2"> Comienza tu proyecto
              </router-link>
            </div>
            <div class="subtext-hero">
              <a class="homelink" > ¿quieres inscribir a tu clase? </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section " id="explanation">
      <div class="container">

        <div class="columns reverse-row">
          <div class="column justify-vertical is-5 is-offset-2">
            <div id="previewer-container">
              <transition name = "slidevertical" mode = "out-in">
                <div v-show = "!editorConfig.isMobile || editorConfig.isSketchRunning" class = "previewer-wrapper" :class = "{ 'previewer-fullscreen': editorConfig.isPreviewingFullscreen, 'previewer-scaled': editorConfig.isMobile ? false : editorConfig.isSketchScaled}">
                  <previewer id = "previewer" :project = "project" :autoplay = "true"></previewer>
                </div>
              </transition>

              <div class = "sketch-selector">
                <button v-on:click = "previousProject" class = "btn btn-icon"><span class = "material-icons md-24">chevron_left</span></button>
                <div class = "info">
                  <span class = "author">{{project.name}}</span>
                  <span v-if = "project.owner">{{project.owner.name}}</span>
                </div>
                <button v-on:click = "previousProject" class = "btn btn-icon"><span class = "material-icons md-24">chevron_right</span></button>
              </div>
            </div>
          </div>
          <div class="column justify-vertical is-5">
            <div class="std" id="explanation-text">
              ¿eres <strong> estudiante </strong> de programación?
              No importa si estudias diseño o ingenieria, universidad o instituto: Salta de tu pantalla y enseña tus creaciones a todo el mundo desde la fachada de medialab-prado, junto al Paseo del Prado de Madrid
            </div>
            <div  class="std">
            ¿Eres <strong>docente</strong>? Inscribe a tu clase y motívales programar a través de la creación visual
            </div>
            <div class="std">
              <a class="btn1" style="width:100%;"> ¡apunta a tus clases! </a>
            </div>
            <div style="text-align:left">
              <span style="font-size:14px">Premios a los mejores alumnos y a los mejores centros **</span>
              <a class="homelink" href="#faq" > más información </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section is-medium" id="comofunciona">
      <div class="container" >
        <div class="columns is-centered">
          <div class="column is-6">
          <h1  style=" " class="is-size-1 is-size-3-mobile"> Cómo funciona la convocatoria </h1>
            <div class="step">
              <h2> 1 </h2>
              <div >
                <p> Diseña y programa tu proyecto </p>
              </div>
            </div>
            <div class="step">
              <h2> 2 </h2>
              <div >
                <p> Cuando esté listo envíalo antes del <strong> 31 de Mayo de 2019 </strong> </p>
              </div>
            </div>
            <div class="step">
              <h2> 3 </h2>
              <div >
                <p> Todas las creaciones* serán mostradas en la fachada de medialab-prado durante el verano de 2019* </p>
              </div>
            </div>
            <div class="step">
              <h2> 4 </h2>
              <div >
                <p> Recibiras un vídeo con tu proyecto expuesto y te avisaremos de qué dias se mostrará </p>
              </div>
            </div>
            <div class="step">
              <h2> 5 </h2>
              <div >
                <p> Los mejores trabajos y los mejores centros serán premiados </p>
              </div>
            </div>
          </div>
          </div>
        </div>
    </section>
    <section class="section is-medium" id="features" >
      <div class="container">
        <div class="columns ">
            <div class="column" >
              <h1 class="has-text-centered is-size-1 is-size-3-mobile"> Editor Online </h1>
            </div>
        </div>
        <p style="margin:2em 0">Editor online. No necesitas instalar nada</p>
        <div class="columns ">
          <div class="column" >
            <video autoplay loop muted poster="/static/img/home/createProject_cover.jpg" >
              <source type="video/mp4" src="/static/img/home/createProject.mp4">
              <source type="video/ogg" src="/static/img/home/createProject.ogg">
              <source type="video/webm" src="/static/img/home/createProject.webm">
            </video>
            <!--<img src="/static/img/home/feature_example.png" style="width:100%;" />-->
            <h3>
              Multiples librerias
            </h3>
            <p>
              P5.js, Processing.  Three.js y otras próximamente.
            </p>
          </div>
          <div class="column" >
            <video autoplay loop muted poster="/static/img/home/preview_cover.jpg">
              <source type="video/mp4" src="/static/img/home/preview.mp4">
              <source type="video/ogg" src="/static/img/home/preview.ogg">
              <source type="video/webm" src="/static/img/home/preview.webm">
            </video>
            <h3>
              Prueba tus diseños en el navegador
            </h3>
            <p>

            </p>
          </div>
          <div class="column" >
            <video autoplay loop muted poster="/static/img/home/submit_cover.jpg">
              <source type="video/mp4" src="/static/img/home/submit.mp4">
              <source type="video/ogg" src="/static/img/home/submit.ogg">
              <source type="video/webm" src="/static/img/home/submit.webm">

            </video>
            <h3>
              Envía tu proyecto en tu pantalla y miralo transformado en una gigantesca animación LED.
            </h3>
            <p>

            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section is-medium" id="features-profes" >
      <div class="features-profes-inner">
        <div class="container">
          <div class="columns ">
              <div class="column is-offset-1 is-5 justify-vertical" >
                <h1 class="is-size-1" style="color:white; text-align:center" > Ventajas <br/>
                      para<br/>
                      docentes
                </h1>
              </div>
              <div class="column" >
                <div class="features-profes-card">
                  <p>
                    Motiva a tus estudiantes con un <strong> gran objetivo </strong>
                  </p>
                  <p>
                    Crea una clase y añade fácilmente estudiantes
                  </p>
                  <p>
                    <strong>  Revisa el código fuente </strong>  de los estudiantes que quieran compartirlo contigo
                  </p>
                  <p>
                    Recibe <strong> notificaciones </strong> y estadísticas de la actividad de tus estudiantes.
                  </p>
                  <p>
                    Deja comentarios y recibe un análisis automatizado del código *
                  </p>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section" id="faq">
      <div class="container">
        <div class="columns is-centered " >
            <div class="column is-12 " >
              <h1 class="">Preguntas Frecuentes</h1>
              <h2 style="margin-top:20px;">  Manda tu proyecto desde el 1 de diciembre de 2018 hasta el 31 de mayo de 2019 </h2>
            </div>
          </div>
          <div class="columns is-centered is-8 is-variable is-desktop">
            <div class="column">
              <div class="pregunta">
                <h2> ¿Quién puede participar? </h2>
                <p> Estudiantes de enseñanza media y superior. No importa que estudies informática, diseño o bellas artes.
                  Tampoco si vienes de un módulo de formación profesional, de secundaria o de estudios superiores.
                </p>
              </div>
              <div class="pregunta">
                <h2> ¿Puedo participar si mi profesor no nos inscribe? </h2>
                <p> Si, pero si ganas algún premio nos tendremos que asegurar de que eres realmente un estudiante y no Mr Dob aburrido.  </p>
              </div>
              <div class="pregunta">
                <h2> ¿Qué categorías?? </h2>
                <p> Dividimos entre estudiantes de enseñanzas medias y superiores </p>
              </div>
            </div>
            <div class="column">
              <div class="pregunta">
                <h2> ¿Qué premios habrá? </h2>
                <p> Aun no están decididos, estamos buscando patrocinadores para los premios.  </p>
              </div>
              <div class="pregunta">
                <h2> Soy profesor, ¿Qué tengo que hacer para participar? </h2>
                <p> Crea una cuenta de usuario, después crea una clase y distribuye el código de acceso entre tus alumnos.
                    No tienes que hacer nada especial, pero si quieres puedes revisar su trabajo on-line.
                </p>
              </div>
              <div class="pregunta">
                <h2> Soy estudiante, pueden ver mis profesores todos mis proyectos </h2>
                <p> No, sólo los que tu les autorices     </p>
              </div>
            </div>
          </div>
        </div>
    </section>

    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          Programalaplaza
           The website content
          is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
        </p>
      </div>
    </footer>
</div>
</template>
<script>
import Previewer from '../Previewer/Previewer'
export default {
  name: 'Home',
  components: {
    Previewer
  },
  data: () => ({
    currentProjectPos: 0,
    studentText: null,
    studentTextOptions: ['estudiantes', 'makers', 'aprendices', 'curios', 'lalala', 'lololo'],
    studentTextIndex: 0
  }),
  watch: {
    'state.gallery.fetched': function (val) {
      console.log('watching ', val)
      this.loadRandomProject()
    }
  },
  computed: {
    project () {
      return this.$store.state.project
    },
    state () {
      return this.$store.state
    },
    editorConfig () {
      return this.$store.state.editorConfig
    },
    gallery () {
      return this.$store.state.gallery.fetched.results
    }
  },
  methods: {
    loadGallery () {
      let query = {
        params: {
          page: 1,
          call: 1
        }
      }
      console.log(query)
      this.$store.dispatch('fetchProjectList', query)
    },
    loadProject () {
      let id = this.gallery[this.currentProjectPos].id
      console.log('loading', id)
      this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': false })

      setTimeout(() => {
        this.$store.dispatch('fetchProject', id)
        this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': true })
      }, 200)
    },
    loadRandomProject () {
      this.currentProjectPos = 0
      this.loadProject()
    },
    previousProject () {
      this.currentProjectPos++
      this.loadProject()
    },
    nextProject () {
      this.currentProjectPos--
      this.loadProject()
    }
  },
  created () {
    // load gallery list
    this.loadGallery()
  }
}
</script>
<style lang="less" scoped>
@import  "../../assets/styles/main.less";
@page_margin: 16px;
#homepage{
  p,div{
    font-family: "Open Sans", sans-serif
  }
}
h1,h2,h3{
  font-family: "Share Tech", sans-serif
}
.full-width{
  margin:-@page_margin;
}
.full-width-padding{
  margin: 0 -@page_margin;
  padding: 0 @page_margin;
}
.reverse-row{
  flex-direction: row-reverse;
}

a,p,body,div{
  font-size: 18px;
  line-height: 140%;
}

a{
  color:#27AE60;
  border-bottom: black 1px dashed;
  padding:0px;
  font-size: 14px;
}
#hero{
  margin-top:50px;
  .text-container{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .subtext-hero{
    text-align:left;
    margin-right:8px;
    margin-top:16px;
  }
  .btn-container{
    margin-top:32px;
    text-align: left;
    padding-left:00px;
    width:200%;
  }
  .catch-phrase-container{
    background: white;
    width: 200%;
    z-index: 100;
  }
  #btn2{
    display: flex;
    border: 2px solid black;
    text-align: center;
    font-weight: @font-normal;
    font-size: 18px;
    color:black;
  }

}
h1{
  font-style: normal;
  font-size: 40px;
  line-height: 1.1em;
}
h1.rojo{
  color:#ED225D;
  text-align: right;
  font-size:80px;
}
h1.verde-inv{
  background-color: @greencolor;
  padding:8px;
  color: white;
     border:2px black solid;
     border-radius: 8px;
}
div.std{
  margin-top:32px;
}
#comofunciona{
  h1{
    margin-bottom:1em;
    text-align: center;
  }
  h2{
    font-size: 50px;
    display: inline-block;
    font-weight: lighter;
  }

    animation: colorchange2 80s; /* animation-name followed by duration in seconds*/
         /* you could also use milliseconds (ms) or something like 2.5s */
    -webkit-animation: colorchange2 80s; /* Chrome and Safari */
    animation-iteration-count:infinite;
   background: linear-gradient( 0, #fff, #fff 30%, #27AE60 30% );
}

#comofunciona div.step{
  margin-bottom:2rem;
  display: flex;
  justify-content: flex-start;
  min-height: 1.2em;
  h2{
    font-size:25px!important;
    font-family: Montserrat;
    align-self: center;
    margin-right: 0.5em;
    color: black;
    min-width: 0.7em;
  }
  p{
    display: inline;
    font-weight: 500;
  }
  div{
    display: inline-block;
  }
}
section#features{
  h3{
    font-weight: bold;
  }
}

.framefachadatop{
  height: 60px;
}

#features-profes{
    animation: colorchange 40s; /* animation-name followed by duration in seconds*/
         /* you could also use milliseconds (ms) or something like 2.5s */
    -webkit-animation: colorchange 40s; /* Chrome and Safari */
    animation-iteration-count:infinite;
   background: linear-gradient( 0, #fff, #fff 30%, #27AE60 30% );

   margin-bottom:2em;

}
@keyframes colorchange
{
  0%   {background: @greencolor;}
  33%  {background: @bluecolor;}
  66%  {background: @redcolor;}
  100%   {background: @greencolor;}
}

@-webkit-keyframes colorchange /* Safari and Chrome - necessary duplicate */
{
  0%   {background: @greencolor;}
  33%  {background: @bluecolor;}
  66%  {background: @redcolor;}
  100%   {background: @greencolor;}
}

@keyframes colorchange2
{
  0%   {background: @greencolor;}
  33%  {background: @bluecolor;}
  66%  {background: @greencolor;}
  100%   {background: @bluecolor;}
}

@-webkit-keyframes colorchange2 /* Safari and Chrome - necessary duplicate */
{
  0%   {background: @greencolor;}
  33%  {background: @bluecolor;}
  66%  {background: @greencolor;}
  100%   {background: @bluecolor;}
}

.features-profes-card{
  background-color:white;
  padding:1em;
  border-radius: 32px;
  border: 4px solid black;
  p{
    margin:1em 2em;
  }
}

#previewer-container {
  margin: 80px 0px 40px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: center;
  align-items: center;
}

.sketch-selector {
  display: flex;
  margin-top: 10px;

  .info {
    width: 200px;
  }

  span {
    display: block;
  }

  .author {
    font-weight: 800;
  }
}

.previewer-wrapper {
  &.previewer-scaled {
    .previewer {
      transform: scale3d(1.65, 1.65, 1) translate3d(0px, 20px, 0px);
      margin-bottom: 92px;
    }
  }

  &.previewer-fullscreen {
    transform: scale3d(2.5, 2.5, 1);
    // transform-origin: bottom left;
  }
}

.justify-vertical{

  display: flex;
  flex-direction: column;
  justify-content: center;
}
#faq{
  margin-top:-40px;

  // background: url('/static/img/home/bg.svg') no-repeat;
  // background-position: top left;

  h2{
    font-weight: bold;
  }
  .pregunta{
    padding: 1em 0;
  }
}
@media (max-width: 768px) {
  #homepage{
  }
  .framefachadatop{
    height:40px;
  }
  div.catch-phrase-container{
    margin: 0;
    max-width: 100%;
  }
  .btn-container{
    margin-top: 32px;
    text-align: left;
    padding-left: 0;
    max-width: 100%;
  }
  .btn1{
    width:100%;
  }
  #hero{
    .text-container{
        order: 2
    }
    .video-container{
      order: 1
    }
  }
  #previewer-container{
    min-height:250px;
    margin-top:100px;
  }
  .video-container{
    .full-width
  }
  h1.rojo{
    font-size:55px;
  }
  #features-profes{
    .full-width-padding
  }
  #features-profes div.features-profes-inner{
    background: transparent;
  }
  .features-profes-card{
    margin:1em;
    p{
      margin: 1em 0.5em;
    }
  }

  #comofunciona h1{
    margin-top:30px;
  }
  .step{
    margin: 1em 0.5em;
  }
  footer{
    .full-width-padding;
    padding-top:40px;
    padding-bottom:40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/HomeBackup.vue